import React from 'react';

export default function InitialAvatar({ firstName, lastName, className = '' }) {
  const getCharAt = (str, index = 0) => {
    return str && str.length > 0 ? str.charAt(index) : '';
  };

  const firstLetter = getCharAt(firstName);
  const secondLetter = getCharAt(lastName);

  return (
    <div
      className={`h-6 w-6 md:h-10 md:w-10 rounded-full bg-primary-400 text-white text-xs md:text-base flex items-center justify-center ${className}`}
    >
      {firstLetter.toUpperCase()}
      {secondLetter.toUpperCase()}
    </div>
  );
}
